module.exports = __webpack_public_path__ + "static/media/Bird12.e79d4ef5.jpg";